import { themes } from "./themes";

/**
 * Apply CSS variables to document root for the resolved theme id.
 * Does not alter legacy component styles — only sets custom properties.
 */
export function applyThemeToDocument(themeId) {
  if (typeof document === "undefined") return;
  const theme = themes[themeId] || themes.light;
  const root = document.documentElement;
  root.setAttribute("data-tra-theme", theme.id);
  Object.entries(theme.cssVars).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
}

/**
 * Apply theme CSS variables on a subtree (e.g. player platform shell) without changing :root.
 * @returns cleanup function
 */
export function applyThemeToElement(element, themeId) {
  if (!element) return () => {};
  const theme = themes[themeId] || themes.light;
  Object.entries(theme.cssVars).forEach(([key, value]) => {
    element.style.setProperty(key, value);
  });
  element.setAttribute("data-tra-theme", theme.id);
  return () => {
    Object.keys(theme.cssVars).forEach((key) => {
      element.style.removeProperty(key);
    });
    element.removeAttribute("data-tra-theme");
  };
}

/** Claude-approved player profile palette (follows app light/dark mode). */
export function applyProfileThemeToElement(element, resolvedAppThemeId) {
  const profileThemeId = resolvedAppThemeId === "light" ? "profileLight" : "profileDark";
  return applyThemeToElement(element, profileThemeId);
}

export function resolveSystemTheme() {
  if (typeof window === "undefined" || !window.matchMedia) return "light";
  return window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
}

export function resolveThemeId(mode) {
  if (mode === "system") return resolveSystemTheme();
  return mode === "light" ? "light" : "dark";
}
